<template>
  <div id="expenses-details" class="wrrapper">
    <page-heading title="Expense Details" back>
      <template #content>
        <div class="flex align-center">
          <Select
            v-if="isAdmin"
            class="mr-2"
            styles="expenses-select"
            :input="handleBranchChange"
            :options="brachData"
            :placeholder="
              brachData.length
                ? brachData && brachData.find(item => item.key == 1).name
                : ''
            "
          />
          <DateRangePicker @update="updateDate" />
          <div class="flex align-center ml-2 cursor" @click="printReport">
            <img src="@/assets/print-icon.png" alt="print" />
          </div>
        </div>
      </template>
    </page-heading>
    <div id="print--report">
      <data-table :cols="columns" :rows="details" :loading="isLoading" total>
        <template slot="action" slot-scope="{ actions }">
          <dropdown-menu
            :rowData="actions"
            :handleItemClick="handleExpenses"
            :items="['Edit', 'Delete']"
          />
        </template>
      </data-table>
    </div>
    <modal
      title="Update Expense"
      name="expensesUpdate"
      class="custom-modal"
      height="auto"
      width="600"
      :adaptive="true"
    >
      <template v-slot:content>
        <form @submit.prevent>
          <Select
            class="mb-base"
            label="Type"
            :value="paymentType"
            :input="handleCreditDebit"
            :options="['Credit', 'Debit']"
            :clearable="false"
          />
          <Input
            class="mb-base"
            label="Amount"
            type="number"
            v-model="expenses.amount"
          />
          <TextArea
            styles="mb-base"
            label="Narration"
            rows="3"
            name="narration"
            v-model="expenses.narration"
          />
          <Button
            className="button--primary"
            title="Update"
            :onClick="handleUpdate"
          ></Button>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
import DropdownMenu from "@/components/DropdownMenu.vue";
import DateRangePicker from "@/components/DateRangePIcker.vue";
import Select from "@/components/Select.vue";
import Input from "@/components/Input.vue";
import TextArea from "@/components/TextArea.vue";
import Modal from "@/components/Modal.vue";
import Button from "@/components/Button.vue";
import printDiv from "@/utils/print";
import { mapActions, mapGetters } from "vuex";
import { formatCreditDebit, formatExpenseType } from "@/utils/helpers";
import { formatedDate } from "@/utils/helpers";
import { getBranchLogo } from "../../../utils/helpers";
export default {
  components: {
    DateRangePicker,
    DropdownMenu,
    DataTable,
    TextArea,
    Input,
    Select,
    Button,
    Modal
  },
  data() {
    return {
      isLoading: false,
      expenses: {},
      paymentType: "",
      isAdmin: false,
      brachData: [],
      bussinessLogoUrl: "",
      branchLogoUrl: "",
      expenceId: null,
      filters: {
        start_date: formatedDate(),
        end_date: formatedDate()
      },
      id: "",
      columns: [
        {
          column: "created_at",
          label: "Created At",
          width: "180",
          sortable: true
        },
        {
          column: "narration",
          label: "Narration",
          width: "300",
          sortable: true
        },
        { column: "type", label: "Type", sortable: true },
        {
          column: "amount",
          label: "Amount",
          formatAmount: true,
          sortable: true,
          sum: true
        },
        { column: "action", label: "Action" }
      ]
    };
  },
  methods: {
    ...mapActions("expenses", [
      "expensesDetails",
      "expensesDetailsUpdate",
      "expensesDetailsDelete"
    ]),
    ...mapActions("expenses", ["fetchBranch"]),
    updateDate(val) {
      this.filters.end_date = formatedDate(val.endDate);
      this.filters.start_date = formatedDate(val.startDate);
      this.expensesDetails({
        id: this.$route.params.id,
        payload: this.filters
      });
    },
    handleExpenses(val, rowData) {
      if (val == "Edit") {
        this.$modal.show("expensesUpdate");
        this.expenses.amount = rowData.amount;
        this.expenses.narration = rowData.narration;
        this.id = rowData.id;
        this.paymentType = rowData.type;
      } else if (val == "Delete") {
        this.expensesDetailsDelete(rowData.id);
      }
    },
    handleUpdate() {
      this.expensesDetailsUpdate({ id: this.id, payload: this.expenses })
        .then(() => {
          this.$modal.hide("expensesUpdate");
        })
        .catch(() => this.$modal.hide("expensesUpdate"));
    },
    handleCreditDebit(val) {
      this.paymentType = val;
      this.expenses.type = formatExpenseType(val);
    },
    handleBranchChange(val) {
      if (val && val !== null) {
        const object = getBranchLogo(this.fetchUserBranch, val.key);
        this.branchLogoUrl = object;
        this.filters.branchId = val.key;
        this.expensesDetails({
          id: this.$route.params.id,
          payload: this.filters
        });
      }
      if (val == null) {
        this.filters.branchId = this.userInfo?.userBranchId;
        this.expensesDetails({
          id: this.$route.params.id,
          payload: this.filters
        });
      }
    },
    printReport() {
      const details = {
        title: "Expence Report",
        printedBy: this?.$store?.getters["auth/userInfo"].full_name,
        startDate: this.filters.start_date,
        endDate: this.filters.end_date,
        imageUrl: this.bussinessLogoUrl,
        imageUrl2: this.branchLogoUrl
      };

      printDiv("print--report", details);
    }
  },
  computed: {
    ...mapGetters("expenses", ["detailExpenses"]),

    ...mapGetters({
      userInfo: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch"
    }),
    details() {
      const data = this.detailExpenses.filter(
        item => item.expenseTypeId == this.expenceId
      );
      return (
        this.detailExpenses &&
        data.map(item => ({
          ...item,
          type: formatCreditDebit(item.type)
        }))
      );
    }
  },
  async mounted() {
    // this.isLoading = true;
    this.isAdmin = this.userInfo.userRole.some(({ name }) => name === "admin");
    this.expenceId = this.$route.params.id;
    await this.fetchBranch();
    await this.fetchUserBranch?.map(elem => {
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    this.filters.branchId = this.userInfo?.userBranchId;

    this.bussinessLogoUrl = this.userInfo?.bussinessLogoUrl;

    this.branchLogoUrl = getBranchLogo(
      this.fetchUserBranch,
      this.userInfo.userBranchId
    );
    this.filters.start_date = "";
    this.filters.end_date = "";
    await this.expensesDetails({
      id: this.$route.params.id,
      payload: this.filters
    })
      .then(() => (this.isLoading = false))
      .catch(() => (this.isLoading = false));
  }
};
</script>

<style></style>
